import { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { createProduct, errMsg } from "../lib/api";

const FIELDS = [
  ["code", "Amazon item-country", "DCPAC1700-UK"],
  ["friendly_name", "Friendly name", "BT1"],
  ["sap_code", "SAP code", "36676"],
  ["description", "SAP description", "BP1 MAILER BAG"],
  ["pallet_qty", "Units per pallet", "14000"],
];

export const AddProductDialog = ({ onSaved }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({});
  const submit = async (e) => {
    e.preventDefault();
    try {
      await createProduct({ ...form, pallet_qty: form.pallet_qty ? Number(form.pallet_qty) : null });
      await onSaved();
      toast.success(`${form.code} added`);
      setForm({});
      setOpen(false);
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="add-product-btn" variant="outline" className="border-slate-700 bg-slate-900 text-slate-200 hover:bg-slate-800">
          <Plus className="mr-1 h-4 w-4" /> Add product
        </Button>
      </DialogTrigger>
      <DialogContent className="border-slate-700 bg-[#131b29] text-slate-100">
        <DialogHeader><DialogTitle className="font-display text-2xl uppercase">Link a product to SAP</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {FIELDS.map(([k, label, ph]) => (
            <div key={k} className="space-y-1">
              <Label className="text-xs text-slate-400">{label}</Label>
              <Input data-testid={`add-product-${k}`} required={k === "code"} placeholder={ph} value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="border-slate-700 bg-[#182232]" />
            </div>
          ))}
          <Button data-testid="add-product-submit" type="submit" className="w-full bg-sky-600 text-white hover:bg-sky-500">Add product</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
